import schoolList from '@/views/schoolManage/schoolList';
import schoolListAbc from '@/views/schoolManage/schoolListAbc';
import schoolListCcb from '@/views/schoolManage/schoolListCcb';
import schoolAdd from '@/views/schoolManage/schoolAdd';
import schoolEdit from '@/views/schoolManage/schoolEdit';
import schoolDetail from '@/views/schoolManage/schoolDetail';
import schoolPermission from '@/views/schoolManage/schoolPermission';
import schoolGrant from '@/views/schoolManage/schoolGrant';
import schoolIntGrant from '@/views/schoolManage/schoolIntGrant';
import newOrderList from '@/views/schoolManage/newOrderList';
import activatingCodeList from '@/views/schoolManage/activatingCodeList';
import externalContact from '@/views/schoolManage/externalContact';
import appInsertIndex from '@/views/appInsert/appInsertIndex';
import schoolModuleRolePermissionList
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList';
import schoolModuleRolePermissionAdd
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd';
import schoolModuleRolePermissionEdit
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit';

import schoolRoleList from '@/views/schoolManage/schoolRole/schoolRoleList';
import schoolRoleEdit from '@/views/schoolManage/schoolRole/schoolRoleEdit';
import schoolRoleUserList from '@/views/schoolManage/schoolRole/schoolRoleUserList';

import schoolAppList from '@/views/schoolManage/schoolAppManage/schoolAppList';
import schoolAppInteDetail from '@/views/schoolManage/schoolAppManage/schoolAppInteDetail';

import schoolAdmin from '@/views/schoolManage/schoolAdmin';

import schoolSuite from '@/views/schoolManage/schoolSuite';

import promoteGrade from '@/views/schoolManage/promoteGrade';
export default [
    {
        path: 'newiPayment',
        redirect: 'newiPayment/homePage'
    },
    {
        path: 'newiPayment/homePage',
        component: () => import('@/views/iPayment/homePage/index')
    },
    {
        path: 'newiPayment/fundApplicationApproval/fundApplicationApprovalIndex',
        component: () => import('@/views/iPayment/fundApplicationApproval/fundApplicationApprovalIndex')
    },
    {
        path: 'newiPayment/fundApplicationApproval/fundApplicationApprovalInfo',
        component: () => import('@/views/iPayment/fundApplicationApproval/fundApplicationApprovalInfo')
    },
    {
        path: 'newiPayment/fundApplicationApproval/newfundApplicationApprovalIndex',
        component: () => import('@/views/iPayment/fundApplicationApproval/newfundApplicationApprovalIndex')
    },
    {
        path: 'newiPayment/fundApplicationApproval/newfundApplicationApprovalInfo',
        component: () => import('@/views/iPayment/fundApplicationApproval/newfundApplicationApprovalInfo')
    },
    {
        path: 'newiPayment/appInsert/appInsertIndex',
        component: appInsertIndex
    },

    {
        path: 'newiPayment/schoolManage/schoolList',
        component: schoolList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'newiPayment/schoolManage/schoolListAbc',
        component: schoolListAbc,
        meta: {
            isCached: true
        }
    },
    {
        path: 'newiPayment/schoolManage/schoolListCcb',
        component: schoolListCcb,
        meta: {
            isCached: true
        }
    },
    {
        path: 'newiPayment/schoolManage/schoolAdd',
        component: schoolAdd
    },
    {
        path: 'newiPayment/schoolManage/schoolEdit',
        component: schoolEdit
    },
    {
        path: 'newiPayment/schoolManage/schoolDetail',
        component: schoolDetail
    },
    {
        path: 'newiPayment/schoolManage/schoolPermission',
        component: schoolPermission
    },
    {
        path: 'newiPayment/schoolManage/schoolGrant',
        component: schoolGrant
    },
    {
        path: 'newiPayment/schoolManage/newOrderList',
        component: newOrderList
    },
    {
        path: 'newiPayment/schoolManage/schoolIntGrant',
        component: schoolIntGrant
    },
    {
        path: 'newiPayment/schoolManage/activatingCodeList',
        component: activatingCodeList
    },
    {
        path: 'newiPayment/schoolManage/externalContact',
        component: externalContact
    },
    {
        path: 'newiPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList',
        component: schoolModuleRolePermissionList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'newiPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd',
        component: schoolModuleRolePermissionAdd
    },
    {
        path: 'newiPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit',
        component: schoolModuleRolePermissionEdit
    },
    {
        path: 'newiPayment/schoolManage/schoolRole/schoolRoleList',
        component: schoolRoleList
    },
    {
        path: 'newiPayment/schoolManage/schoolRole/schoolRoleEdit',
        component: schoolRoleEdit
    },
    {
        path: 'newiPayment/schoolManage/schoolRole/schoolRoleUserList',
        component: schoolRoleUserList
    },
    {
        path: 'newiPayment/schoolManage/schoolAppManage/schoolAppList',
        component: schoolAppList,
        meta: {
            isCached: true
        }
    },
    {
        path: 'newiPayment/schoolManage/schoolAppManage/schoolAppInteDetail',
        component: schoolAppInteDetail
    },
    {
        path: 'newiPayment/schoolManage/schoolAdmin',
        component: schoolAdmin
    },
    {
        path: 'newiPayment/schoolManage/schoolSuite',
        component: schoolSuite
    },
    {
        path: 'newiPayment/schoolManage/promoteGrade',
        component: promoteGrade
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/newsPayment.js